import { Button } from '@/ui'
import { useTranslation } from 'react-i18next'
import { formatSlotDisplay } from './calendar-math'
import type { SelectedSlot } from './types'

interface Props {
	slot: SelectedSlot
	durationMinutes: number
	candidateTimezone: string
	isSubmitting: boolean
	onConfirm: () => void
	onClear: () => void
}

export function BookingConfirmPanel(
	{ slot, durationMinutes, candidateTimezone, isSubmitting, onConfirm, onClear }: Props,
) {
	const { t } = useTranslation('booking')
	const display = formatSlotDisplay(slot, durationMinutes, candidateTimezone)

	return (
		<div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
			<p className="text-sm font-medium text-gray-900">{display}</p>
			<div className="mt-3 flex gap-2">
				<Button
					type="neutral"
					size="short"
					fullWidth={true}
					isLoading={isSubmitting}
					onClick={onConfirm}
				>
					{t('confirm.book_this_time')}
				</Button>
				<Button
					type="subtle"
					size="short"
					disabled={isSubmitting}
					onClick={onClear}
				>
					{t('confirm.change')}
				</Button>
			</div>
		</div>
	)
}
